<template>
  <div>
    <div class="content">
      <AsignarAvlsModal />
      <div class="container-fluid h-100">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <div class="col h-100">
              <card-item
                class="striped-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <div class="container-fluid">
                  <div class="row">
                    <div class="col d-flex justify-content-between">
                      <div>
                        <h4 class="card-title">Acceso para Testeos</h4>
                        <p class="card-category">Listado</p>
                      </div>
                      <div>
                        <button
                          @click="abrirModalAsignarAvls"
                          class="btn btn-primary mr-2 custom-primary-disabled"
                          :disabled="seleccionados.length > 0"
                          :title="
                            seleccionados.length > 0
                              ? 'Tiene seleccionados AVLs para eliminar accesos'
                              : ''
                          "
                        >
                          Agregar accesos
                        </button>
                        <button
                          type="button"
                          @click="submit"
                          class="btn btn-danger custom-disabled"
                          :disabled="!idContratos.length"
                          :title="!idContratos.length ? 'Seleccione AVLs' : ''"
                        >
                          Eliminar accesos
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container-fluid h-100">
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label for="quickFilter" class="label"
                          >Filtro rápido</label
                        >
                        <input
                          type="text"
                          id="quickFilter"
                          v-model="quickFilter"
                          class="form-control"
                        />
                      </div>
                      <div class="row mb-2 ml-0">
                        <div
                          v-for="(item, index) in badgesOrdenados"
                          :key="`contrato-${item.id_contrato}-${index}`"
                        >
                          <span class="badge badge-custom">
                            {{ item.patente }}
                            <template
                              v-if="
                                item.dominio && item.dominio !== item.patente
                              "
                            >
                              - {{ item.dominio }}
                            </template>

                            <button
                              @click="quitarPatente(item)"
                              class="btn btn-xs btn-badge-close"
                              title="Quitar"
                            >
                              ×
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="height: 100%">
                    <div class="col" style="position: relative; height: 100%">
                      <ag-grid-vue
                        style="width: 100%; height: 50vh"
                        class="ag-theme-alpine"
                        :columnDefs="columnDefs"
                        :rowData="rowData"
                        @grid-ready="onGridReady"
                        @selection-changed="onSelectionChanged"
                        :defaultColDef="defaultColDef"
                        :rowSelection="'multiple'"
                        :rowMultiSelectWithClick="true"
                        :gridOptions="gridOptions"
                        :getContextMenuItems="getContextMenuItems"
                      >
                      </ag-grid-vue>
                    </div>
                  </div>
                </div>
              </card-item>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmación Inicial -->
    <b-modal
      id="ConfirmacionModal"
      size="md"
      scrollable
      title="Confirmar Eliminación"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-text-variant="dark"
      body-bg-variant="light"
    >
      <template>
        <div class="d-flex align-items-center w-100">
          <h5 class="modal-title">
            ¿Desea eliminar los siguientes accesos a AVLs?
          </h5>
        </div>
      </template>

      <div class="confirmation-container border-warning pl-3">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead class="thead-light">
              <tr>
                <th>ID AVL</th>
                <th>Patente</th>
                <th>Instalador</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in seleccionadosOrdenados"
                :key="`confirm-${item.id_avl}-${index}`"
              >
                <td>{{ item.id_avl }}</td>
                <td>
                  {{ item.patente }}
                  <span v-if="item.dominio && item.dominio !== item.patente">
                    - {{ item.dominio }}
                  </span>
                </td>
                <td>{{ item.nombre_instalador }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="cancelarConfirmacion">
            Cancelar
          </button>
          <button
            class="btn btn-warning text-dark font-weight-bold"
            @click="confirmarPrimeraVez"
          >
            Confirmar
          </button>
        </div>
      </div>
    </b-modal>
    <!-- Modal de Captcha para confirmación -->
    <b-modal
      id="CaptchaModal"
      size="md"
      title="¡Atención! Verificación Requerida"
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="warning"
      header-text-variant="dark"
      body-bg-variant="light"
      header-border-variant="warning"
    >
      <div class="captcha-container border-warning pl-3">
        <p class="text-center mb-3 font-weight-bold text-dark">
          <i class="fas fa-shield-alt mr-1"></i>
          Está por eliminar los AVLs: <strong>{{ idAvls }}</strong>
          Por favor, resuelva la siguiente operación:
        </p>
        <MathCaptcha v-model="isCaptchaValid" />
        <div class="alert alert-warning small mt-3">
          <i class="fas fa-info-circle"></i>
          Esta verificación es necesaria para operaciones sensibles que
          involucran eliminación de accesos de avls a instaladores.
        </div>
        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-secondary" @click="cancelarCaptcha">
            <i class="fas fa-times mr-1"></i> Cancelar
          </button>
          <button
            class="btn btn-warning text-dark font-weight-bold"
            @click="confirmarEliminacion"
          >
            <i class="fas fa-check mr-1"></i> Confirmar Eliminación
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import { get } from "lodash-es";
import axios from "axios";
import moment from "moment";
import AsignarAvlsModal from "./AsignarAvlsModal.vue";
import CardItem from "@/components/Cards/CardItem.vue";
import MathCaptcha from "../../pages/Clientes/shared/MathCaptcha.vue";

export default {
  name: "AccesoATesteosList",
  components: {
    AgGridVue,
    AsignarAvlsModal,
    CardItem,
    MathCaptcha,
  },

  data() {
    return {
      testeo: [],
      trazabilidad: [],
      modifyClienteNodeId: null,
      rowData: null,
      quickFilter: "",
      seleccionados: [],
      idAvls: "",
      idContratos: "",
      isCaptchaValid: false,
      mostrarCaptcha: false,

      // ag-grid config
      modules: AllModules,
      gridApi: null,
      columnApi: null,

      gridOptions: {
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            { statusPanel: "agTotalRowCountComponent", align: "center" },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" },
          ],
        },
        enableClipboard: true,
        enableRangeSelection: true,
        suppressCopyRowsToClipboard: false,
      },

      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
        wrapText: true,
        autoHeight: true,
        minWidth: 120,
        enableCellTextSelection: true,
        ensureDomOrder: true,
      },

      columnDefs: [
        {
          headerName: "#Id AVL",
          field: "id_avl",
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          maxWidth: 130,
        },
        {
          headerName: "Instalador",
          field: "nombre_instalador",
          minWidth: 160,
          sort: "asc",
        },
        {
          headerName: "Fecha Alta",
          field: "fecha_alta",
          minWidth: 160,
          valueFormatter: (params) => {
            if (params.value) {
              return moment(params.value).format("DD/MM/YYYY HH:mm");
            }
            return "";
          },
        },
        {
          headerName: "#Contrato",
          field: "id_contrato",
          minWidth: 110,
          hide: true,
        },
        {
          headerName: "IMEI",
          field: "imei",
          minWidth: 160,
        },
        {
          headerName: "Cliente",
          field: "cliente",
          minWidth: 140,
        },
        {
          headerName: "Tipo de Contrato",
          field: "nombre_contrato",
          minWidth: 140,
        },
        {
          headerName: "Patente",
          field: "patente",
        },
        {
          headerName: "Alias",
          field: "dominio",
        },
        {
          headerName: "Marca Modelo",
          cellRenderer: (params) =>
            `${params.data.marca} ${params.data.modelo}`,
          valueGetter: (params) => `${params.data.marca} ${params.data.modelo}`,
          minWidth: 150,
        },
        {
          headerName: "Celular",
          field: "numero",
          minWidth: 160,
        },
      ],
    };
  },

  computed: {
    badgesOrdenados() {
      return [...this.seleccionados].sort((a, b) => {
        return (a.id_avl || 0) - (b.id_avl || 0);
      });
    },

    seleccionadosOrdenados() {
      return [...this.seleccionados].sort((a, b) => {
        // 1. Ordenar por nombre de instalador
        const nombreCompare = this.compararTexto(
          a.nombre_instalador || "",
          b.nombre_instalador || "",
        );
        if (nombreCompare !== 0) return nombreCompare;

        // 2. Ordenar por patente
        return this.compararPatentes(
          (a.patente || "").toString(),
          (b.patente || "").toString(),
        );
      });
    },
  },

  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
    seleccionados() {
      this.actualizarSeleccionPatentes();
    },
  },

  methods: {
    compararTexto(textoA, textoB) {
      return textoA.localeCompare(textoB, "es", { sensitivity: "base" });
    },

    esPatentEspecial(patente) {
      const upper = patente.toUpperCase();
      return (
        upper.startsWith("ID_V:") ||
        upper.startsWith("IDV:") ||
        upper.startsWith("BALCA:") ||
        upper.startsWith("S/P") ||
        upper.startsWith("SP ")
      );
    },

    compararPatentes(patenteA, patenteB) {
      const esEspecialA = this.esPatentEspecial(patenteA);
      const esEspecialB = this.esPatentEspecial(patenteB);

      // Las especiales van al final
      if (esEspecialA && !esEspecialB) return 1;
      if (!esEspecialA && esEspecialB) return -1;

      // Normalizar patentes
      const normA = patenteA.toUpperCase().replace(/\s+/g, "");
      const normB = patenteB.toUpperCase().replace(/\s+/g, "");

      // Si ambas son especiales, comparar directamente
      if (esEspecialA && esEspecialB) {
        return normA.localeCompare(normB, "es");
      }

      // Para patentes normales, separar en segmentos
      const segmentosA = normA.match(/[A-Z]+|[0-9]+/g) || [];
      const segmentosB = normB.match(/[A-Z]+|[0-9]+/g) || [];

      const maxLen = Math.max(segmentosA.length, segmentosB.length);

      for (let i = 0; i < maxLen; i++) {
        const segA = segmentosA[i];
        const segB = segmentosB[i];

        if (!segA) return -1;
        if (!segB) return 1;

        const esNumeroA = /^[0-9]+$/.test(segA);
        const esNumeroB = /^[0-9]+$/.test(segB);

        if (esNumeroA && esNumeroB) {
          const diff = parseInt(segA, 10) - parseInt(segB, 10);
          if (diff !== 0) return diff;
        } else if (!esNumeroA && !esNumeroB) {
          const comp = segA.localeCompare(segB, "es");
          if (comp !== 0) return comp;
        } else {
          return esNumeroA ? 1 : -1;
        }
      }

      return normA.localeCompare(normB, "es");
    },

    ordenarDatos(datos) {
      return datos.sort((a, b) => {
        // 1. Ordenar por nombre de instalador
        const nombreCompare = this.compararTexto(
          a.nombre_instalador || "",
          b.nombre_instalador || "",
        );
        if (nombreCompare !== 0) return nombreCompare;

        // 2. Ordenar por patente
        const patenteCompare = this.compararPatentes(
          (a.patente || "").toString(),
          (b.patente || "").toString(),
        );
        if (patenteCompare !== 0) return patenteCompare;

        // 3. Si todo es igual, ordenar por ID AVL
        return (parseInt(a.id_avl) || 0) - (parseInt(b.id_avl) || 0);
      });
    },

    // ==================== MÉTODOS DE UI ====================

    abrirModalAsignarAvls() {
      this.$bvModal.show("asignarAvlsModal");
    },

    limpiarFiltro() {
      this.quickFilter = "";
    },

    quitarPatente(params) {
      this.seleccionados = this.seleccionados.filter(
        (item) =>
          `${item.id_contrato}-${item.cliente}` !==
          `${params.id_contrato}-${params.cliente}`,
      );
    },
    onSelectionChanged() {
      const selectNodes = this.gridApi.getSelectedNodes();
      this.limpiarFiltro();

      const selectAvls = selectNodes.map((node) => node.data.id_avl);
      const selectContratos = selectNodes.map((node) => node.data.id_contrato);

      this.seleccionados = selectNodes.map((node) => node.data);
      this.idAvls = selectAvls.toString();
      this.idContratos = selectContratos.toString();
      this.isCaptchaValid = false;
    },

    actualizarSeleccionPatentes() {
      const selectNodes = this.gridApi.getSelectedNodes();
      selectNodes.forEach((node) => {
        if (
          !this.seleccionados.find(
            (item) =>
              `${item.id_contrato}-${item.cliente}` ===
              `${node.data.id_contrato}-${node.data.cliente}`,
          )
        ) {
          this.gridApi.deselectNode(node);
        }
      });
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.getContratos();
    },

    async getContratos() {
      this.gridApi.showLoadingOverlay();

      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetContratosDeInstaladores",
          parameters: [],
        });

        if (get(resp, "data.ok", false)) {
          const datos = get(resp, "data.result[0]", []);
          this.rowData = this.ordenarDatos(datos);
        }
      } catch (error) {
        console.error("Error al obtener contratos:", error);
      } finally {
        setTimeout(() => {
          this.gridApi.hideOverlay();
        }, 0);
      }
    },

    // ==================== MÉTODOS DE CONFIRMACIÓN ====================

    async submit() {
      if (!this.idContratos.length) {
        this.$msgBoxOk("Elija al menos un AVL");
        return;
      }
      this.$bvModal.show("ConfirmacionModal");
    },

    cancelarConfirmacion() {
      this.$bvModal.hide("ConfirmacionModal");
    },

    confirmarPrimeraVez() {
      this.$bvModal.hide("ConfirmacionModal");
      this.$bvModal.show("CaptchaModal");
    },

    cancelarCaptcha() {
      this.$bvModal.hide("CaptchaModal");
      this.isCaptchaValid = false;
    },

    async confirmarEliminacion() {
      if (!this.isCaptchaValid) {
        return;
      }

      this.$bvModal.hide("CaptchaModal");

      try {
        const resp = await axios.post("/execute", {
          method: "CLI.EliminarContratosPorIds",
          parameters: [{ name: "id_contratos", value: this.idContratos }],
        });

        if (resp.data.ok) {
          await this.$msgBoxOk("Contratos eliminados correctamente");
          this.limpiarSeleccion();
          await this.getContratos();
        } else {
          await this.$msgBoxOk(
            "Error al eliminar los contratos: " +
              (resp.data.message || "Error desconocido"),
          );
        }
      } catch (error) {
        await this.$msgBoxOk(
          "Error al procesar la solicitud: " + error.message,
        );
      } finally {
        this.isCaptchaValid = false;
        this.mostrarCaptcha = false;
      }
    },

    limpiarSeleccion() {
      this.seleccionados = [];
      this.idAvls = "";
      this.idContratos = "";
      if (this.gridApi) {
        this.gridApi.deselectAll();
      }
    },
  },
};
</script>

<style scoped>
.captcha-container,
.confirmation-container {
  padding: 1rem;
}

/* Botón danger deshabilitado */
.custom-disabled:disabled {
  background-color: #fff;
  border-color: #dc3545;
  color: #dc3545;
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-disabled:not(:disabled) {
  background-color: #fff;
  border-color: #dc3545;
  color: #dc3545;
  cursor: pointer;
  opacity: 1;
}

.custom-disabled:not(:disabled):hover {
  background-color: rgba(221, 221, 221, 0.8);
  border-color: #c82333;
}

/* Botón primary deshabilitado */
.custom-primary-disabled {
  border-color: #007bff;
  color: #007bff;
  cursor: pointer;
}

.custom-primary-disabled:disabled {
  border-color: #007bff;
  color: #007bff;
  cursor: not-allowed;
  opacity: 0.6;
}

.custom-primary-disabled:hover,
.custom-primary-disabled:disabled:hover {
  background-color: rgba(221, 221, 221, 0.8);
  border-color: #007bff;
}
.badge-custom {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 4px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #333;
}

.btn-badge-close {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 50%;
  color: #555;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.btn-badge-close:hover {
  background-color: #f0f0f0;
  color: #d00;
  border-color: #d00;
  transform: scale(1.1);
}
</style>
